import { env } from 'src/config/env';
const CDN_URL = env.cdnUrl || '';

export const cdnImage = (path: string): string => {
  if (!CDN_URL && env.isDev) {
    console.warn('[cdn] VITE_CDN_URL is not configured');
  }
  return `${CDN_URL}/images/${path}`;
};

export { CDN_URL };
